module.exports = __webpack_public_path__ + "img/Stylized Sword-Bloody.14af3398.png";